import { Flex, Button, Heading, Text } from '@chakra-ui/react';
import { FormInput } from '@shared';
import { useTranslation } from 'react-i18next';

export default function LoginForm({ error, isPending }: { error: string | null; isPending: boolean }) {
	const { t } = useTranslation();

	return (
		<>
			<Flex flexDirection={'column'} gap={4} marginBottom={3} alignItems={'left'}>
				<Flex alignItems={'center'} justifyContent={'space-between'} marginBottom={2} gap={2}>
					<Heading size="xl" textAlign={'start'}>
						{t('general.superadmin_login')}
					</Heading>
				</Flex>

				<FormInput isAutocompleteAllowed={true} type="email" label={t('general.email')} isRequired name="email" />
				<Flex flexDirection={'column'}>
					<FormInput isAutocompleteAllowed={true} type="password" label={t('general.password')} isRequired name="password" />
					{error ? (
						<Text data-cy="loginError" textAlign={'start'} color={'red.600'} fontSize={'sm'}>
							{error}
						</Text>
					) : (
						<Text textAlign={'start'} color={'red.600'} fontSize={'sm'}>
							{''}
						</Text>
					)}
				</Flex>
			</Flex>
			<Button id="loginButton" marginTop={2} marginBottom={4} type="submit" disabled={isPending}>
				{isPending ? t('general.logging_in') : t('general.login')}
			</Button>
		</>
	);
}
